import {
  CategoriesState,
  CategoryFilterType,
  addCategoryPayloadType,
  fetchCategoryListPayloadType,
  updateCategoryPayloadType,
} from "../slices/categorySlice"

export const constructGetCategoryListApiRequestParams = (
  category: keyof CategoriesState,
  filters?: CategoryFilterType,
  pagination?: any,
) => {
  const requestParams = {
    ...filters,
    ...pagination,
    category,
    level: category.replace("Category", ""),
  }
  return requestParams
}

export const categoryFilterService = (
  payload: fetchCategoryListPayloadType,
) => {
  return {
    ...(payload.page && {
      page_no: payload.page + 1,
    }),
    ...(payload.pageSize && {
      page_size: payload.pageSize,
    }),

    ...(payload.sortBy !== "none" && {
      sort_by: payload.sortBy,
      order_by: payload.orderBy,
    }),
    ...(payload.source !== "" && {
      source: payload.source,
    }),
    ...(payload.category1 !== "" && {
      level_1: payload.category1,
    }),
    ...(payload.category2 !== "" && {
      level_2: payload.category2,
    }),
    ...(payload.search !== "" && { name: payload.search }),
  }
}

export const createCategoryDTO = (payload: addCategoryPayloadType): any => ({
  category: {
    label: payload.label,
    level: payload.level,
  },
  level_1: payload.category1,
  level_2: payload.category2,
  source: payload.source,
})
export const updateCategoryDTO = (payload: updateCategoryPayloadType): any => ({
  level: payload.level,
  ...(payload.label !== "" && {
    name: payload.label,
  }),
  ...(payload.category1 !== "" && {
    new_level_1_id: payload.category1,
  }),
  ...(payload.category2 !== "" && {
    new_level_2_id: payload.category2,
  }),
  ...(payload.initialCategory2 !== "" && {
    parent_level_2_id: payload.initialCategory2,
  }),
  ...(payload.source !== "" && {
    source: payload.source,
  }),
})
